import { IconExternalLink } from '@tabler/icons-react'
import { FormProps } from 'antd'
import Link from 'next/link'

import { ActionFormItems } from './ActionFormItems'

import { Button } from '@/components/shared-components/BUI/Button'
import { Form, HorizontalForm } from '@/components/shared-components/BUI/Form'
import { DozerLoading } from '@/components/shared-components/DozerLoading'
import { Flexbox } from '@/components/shared-components/Flexbox'
import { ResponsiveDrawer } from '@/components/shared-components/ResponsiveDrawer'
import { routes } from '@/utils/routes'

type Props = {
  actionId: string
  formProps?: FormProps
  open: boolean
  onClose: () => void
  isPublic?: boolean
  builderId: string
  loading?: boolean
  disableRequireAttachments?: boolean
}

export const UpdateActionDrawer: React.FC<Props> = ({
  actionId,
  formProps,
  open,
  onClose,
  loading,
  builderId,
  isPublic,
  disableRequireAttachments = false,
}) => {
  const [form] = Form.useForm()

  return (
    <ResponsiveDrawer
      maxWidth={500}
      title="Update action"
      open={open}
      onClose={onClose}
      destroyOnClose // clean up the form items
      footer={
        <Flexbox justifyContent="space-between">
          <Button variant="primary" onClick={form.submit} loading={loading}>
            Save
          </Button>
          <Link href={routes.actions.edit(actionId)}>
            <Button
              variant="secondary-text"
              icon={<IconExternalLink size={16} />}
            >
              View action
            </Button>
          </Link>
        </Flexbox>
      }
    >
      {!actionId ? (
        <DozerLoading relative loading />
      ) : (
        <HorizontalForm {...formProps} form={form}>
          <ActionFormItems
            builderId={builderId}
            isPublic={isPublic}
            disableRequireAttachments={disableRequireAttachments}
          />
        </HorizontalForm>
      )}
    </ResponsiveDrawer>
  )
}
